function Body({ children, className = "", ...props }) {
	return (
		<tbody {...props} className={`main_table_body ${className}`}>
			{children}
		</tbody>
	);
}

export default Body;
